/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_FloorplanInputs */

const cs_enum_floorplan = /** @type {(inputs: Enum_FloorplanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Půdorys`)
};

const en_enum_floorplan = /** @type {(inputs: Enum_FloorplanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Floor plan`)
};

/**
* | output |
* | --- |
* | "Floor plan" |
*
* @param {Enum_FloorplanInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_floorplan = /** @type {((inputs?: Enum_FloorplanInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_FloorplanInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_floorplan(inputs)
	return cs_enum_floorplan(inputs)
});